export const remindersConstants = {
    errors: {
        fetchFailed: "Failed to load reminders.",
        statsFailed: "Failed to load reminder stats.",
        createFailed: "Failed to create reminder.",
        updateFailed: "Failed to update reminder.",
        deleteFailed: "Failed to delete reminder.",
        dismissFailed: "Failed to dismiss reminder.",
        reactivateFailed: "Failed to reactivate reminder.",
        genericError: "Something went wrong.",
    },
    messages: {
        createSuccess: "Reminder created.",
        updateSuccess: "Reminder updated.",
        deleteSuccess: "Reminder deleted.",
        dismissSuccess: "Reminder dismissed.",
        reactivateSuccess: "Reminder reactivated.",
    },
};
